import React from 'react';
import PopAdminPresenter from "@/presenters/screens/pop-admin.presenter";
import { SingleCollapse } from "@/components/";
import TestBeneficiaries from './SectionBeneficiaries';
import {Enums } from "@utils";

export interface IPropsStep {
    stepsData: any
    infoToDelete: any,
    year: any
    dataColumns: any
}

const Beneficiaries: React.FC<IPropsStep> = ({stepsData, infoToDelete, year, dataColumns} : IPropsStep) => {

    const view: any = {
        state: {
        },
    };
      
    const presenter = new PopAdminPresenter(view);
    
    let hasInfo = infoToDelete.filter((x: any) => (x.listName === Enums.ListTypes.BeneficiariesBySubPr || x.listName === Enums.ListTypes.BeneficiariesByLocation ||
        x.listName === Enums.ListTypes.BeneficiariesByResult || x.listName === Enums.ListTypes.BeneficiariesByOverlap))

    return (
        <>
            { !!dataColumns && !!hasInfo?.length &&
                <SingleCollapse title={presenter.followupLabels.get("stepBeneficiaries")} isOpen={false}>
                    <>
                        <TestBeneficiaries
                            year={year} 
                            stepsData={stepsData}
                            sectionName={"Beneficiarios directos"}
                            section={"bySubProject"}
                            columns={dataColumns} data={infoToDelete.filter((x: any) => (x.listName === Enums.ListTypes.BeneficiariesBySubPr) ).map((y: any) => y.item)}
                        />
                        <TestBeneficiaries
                            year={year} 
                            stepsData={stepsData}
                            sectionName={"Beneficiarios por Localización"}
                            section={"byLocation"}
                            columns={dataColumns} data={infoToDelete.filter((x: any) => (x.listName === Enums.ListTypes.BeneficiariesByLocation) ).map((y: any) => y.item)}
                        />

                        <TestBeneficiaries
                            year={year} 
                            stepsData={stepsData}
                            sectionName={"Beneficiarios por actividad"}
                            section={"byActivity"}
                            columns={dataColumns} data={infoToDelete.filter((x: any) => (x.listName === Enums.ListTypes.BeneficiariesByResult) ).map((y: any) => y.item)}
                        />

                        <TestBeneficiaries
                            year={year} 
                            stepsData={stepsData}
                            sectionName={"Beneficiarios por superposición"}
                            section={"byOverlaps"}
                            columns={dataColumns} data={infoToDelete.filter((x: any) => (x.listName === Enums.ListTypes.BeneficiariesByOverlap) ).map((y: any) => y.item)}
                        />
                        
                    </>
                </SingleCollapse>
            }
        </>
    )
}

export default Beneficiaries;